module.exports = __webpack_public_path__ + "img/stock2.1ba3e4df.png";